import CompatibilityWarning from './CompatibilityWarning';

export const isCompatibleBrowser = userAgent => {
  const isMSIE11 =
    new RegExp('Trident/.*rv:([0-9]{1,}[.0-9]{0,})').exec(userAgent) !== null;
  return (
    /firefox/i.test(userAgent) ||
    (/chrome/i.test(userAgent) &&
      !/android/i.test(userAgent) &&
      !/edge/i.test(userAgent)) ||
    isMSIE11
  );
};

export default CompatibilityWarning;
